import { render } from "./AdminAuth.vue?vue&type=template&id=24409ddd&scoped=true"
import script from "./AdminAuth.vue?vue&type=script&lang=js"
export * from "./AdminAuth.vue?vue&type=script&lang=js"

import "./AdminAuth.vue?vue&type=style&index=0&id=24409ddd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24409ddd"]])

export default __exports__